import graphqlClient from '@/graphql/graphql-client';
import { toScalarListVariables } from '@/graphql/list-query';
import type { ListQueryVariables } from '@/graphql/types';
import { useQuery } from '@tanstack/react-query';

import {
  OrganizationLetterheadsDocument,
  type OrganizationLetterheadsQuery,
} from '@/graphql/generated/graphql';

export type OrganizationLetterheadItem = NonNullable<
  NonNullable<OrganizationLetterheadsQuery['getOrganizationLetterheadss']>['items']
>[number];
export type GetOrganizationLetterheadsResponse = OrganizationLetterheadsQuery;

export const useGetOrganizationLetterheads = (params?: ListQueryVariables<Record<string, unknown>>) => {
  const variables = toScalarListVariables(params, { organizationId: 'OrganizationId' });
  return useQuery({
    queryKey: ['organization-letterheads', variables],
    queryFn: () => graphqlClient.request(OrganizationLetterheadsDocument, variables),
  });
};

export const requestOrganizationLetterheads = (
  params?: ListQueryVariables<Record<string, unknown>>
) => {
  const variables = toScalarListVariables(params, { organizationId: 'OrganizationId' });
  return graphqlClient.request(OrganizationLetterheadsDocument, variables);
};

export const GET_ORGANIZATION_LETTERHEADS_QUERY = OrganizationLetterheadsDocument;
